export default __webpack_public_path__ + "static/media/raki_detail11.73f8f861.jpg";